import React from 'react';
import { isMobile } from '../../utils/ScreenSizeHelper';

function PackagePlanHeadingText() {
  return (
    <div
      style={{
        width: '100%',
        boxSizing: 'border-box',
        padding: '0 16px', // mobile-safe padding
      }}
    >
      {/* Centered content container */}
      <div
        style={{
          maxWidth: '1100px',
          margin: '0 auto', // 👈 centers from left & right
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center', // centers child elements horizontally
        }}
      >
        <div
          style={{
            color: '#1B1642',
            fontSize: isMobile ? '35px' : '55px',
            fontFamily: 'Playfair Display',
            fontWeight: 600,
            textAlign: 'center',
            marginTop: '20px',
          }}
        >
          Simple, fair pricing.
        </div>

        <div
          style={{
            color: '#1B1642',
            fontFamily: 'Segoe UI',
            fontSize: isMobile ? '16px' : '20px',
            textAlign: 'center',
            maxWidth: '830px',
            marginBottom: '20px',
          }}
        >
          We’re the only platform that shares revenue with restaurants - creating an extra stream of
          passive income while giving you control over your local customers and keeping your
          restaurant on top of the platform.
        </div>
      </div>
    </div>
  );
}

export default PackagePlanHeadingText;
